import i18n from "i18next"
import createAxiosInstance from "../axios/axiosCustom"

export async function setStoreData(dispatch) {
  try {
    const t = i18n.t.bind(i18n)

    const axiosCustom = await createAxiosInstance()
    let data = await axiosCustom.get('/type')
    if (!data) return

    const results = data.data.results

    const typeData = results.map(item => ({
      id: item._id,
      name: t(item.name),
    }))

    const categoryData = results
      .flatMap(r => r.categories.map(category => ({
        id: category.id,
        name: t(category.name),
        typeId: r._id,
      })))

    dispatch({ type: 'TYPE_DATA', payload: typeData })
    dispatch({ type: 'CATEGORY_DATA', payload: categoryData })

  } catch (err) {
    console.error("Error in useStoreData:", err)
  }
}